import React from 'react';
import { useVisited } from '../context/VisitedContext';
import './Header.css';

const TOTAL_TEMPLES = 213;

export default function Header({ lang, onLangToggle, view, onViewChange, sidebarOpen, onSidebarToggle }) {
  const { visited, reset } = useVisited();
  const visitedCount = visited.size;

  return (
    <header className="header">
      <div className="header-brand">
        <button className="hamburger-btn" onClick={onSidebarToggle} aria-label="Toggle menu">
          {sidebarOpen ? (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="2" y1="2" x2="16" y2="16"/><line x1="16" y1="2" x2="2" y2="16"/>
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="2" y1="4" x2="16" y2="4"/><line x1="2" y1="9" x2="16" y2="9"/><line x1="2" y1="14" x2="16" y2="14"/>
            </svg>
          )}
        </button>
        <span className="header-om">ॐ</span>
        <div>
          <h1 className="header-title">{lang === 'en' ? 'Divine South' : 'दिव्य दक्षिण'}</h1>
          <p className="header-sub">{lang === 'en' ? 'Temples · Monasteries · Sacred Sites' : 'मंदिर · मठ · पवित्र स्थल'}</p>
        </div>
      </div>
      <div className="header-controls">
        <div className="view-toggle">
          <button className={`view-btn${view !== 'map' && view !== 'nearby' ? ' active' : ''}`} onClick={() => onViewChange('grid')} title="Grid view">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><rect x="0" y="0" width="6" height="6" rx="1"/><rect x="8" y="0" width="6" height="6" rx="1"/><rect x="0" y="8" width="6" height="6" rx="1"/><rect x="8" y="8" width="6" height="6" rx="1"/></svg>
            <span className="view-btn-label">{lang === 'en' ? 'Grid' : 'ग्रिड'}</span>
          </button>
          <button className={`view-btn${view === 'map' ? ' active' : ''}`} onClick={() => onViewChange('map')} title="Map view">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><path d="M7 1a4 4 0 0 0-4 4c0 3 4 8 4 8s4-5 4-8a4 4 0 0 0-4-4zm0 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>
            <span className="view-btn-label">{lang === 'en' ? 'Map' : 'नक्शा'}</span>
          </button>
          <button className={`view-btn${view === 'nearby' ? ' active' : ''}`} onClick={() => onViewChange(view === 'nearby' ? 'grid' : 'nearby')} title="Temples near me">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><circle cx="7" cy="7" r="2.5"/><path d="M7 0v2M7 12v2M0 7h2M12 7h2M2.1 2.1l1.4 1.4M10.5 10.5l1.4 1.4M10.5 3.5l1.4-1.4M2.1 11.9l1.4-1.4"/></svg>
            <span className="view-btn-label">{lang === 'en' ? 'Near Me' : 'पास में'}</span>
          </button>
        </div>
        {visitedCount > 0 && (
          <div className="visited-pill">
            <span className="visited-pill-check">✓</span>
            <span className="visited-pill-count">{visitedCount}</span>
            <span className="visited-pill-sep">/</span>
            <span className="visited-pill-total">{TOTAL_TEMPLES}</span>
            <button className="visited-pill-reset" onClick={reset}>×</button>
          </div>
        )}
        <div className="lang-toggle">
          <button className={`lang-btn${lang === 'en' ? ' active' : ''}`} onClick={() => onLangToggle('en')}>EN</button>
          <button className={`lang-btn${lang === 'hi' ? ' active' : ''}`} onClick={() => onLangToggle('hi')}>हि</button>
        </div>
      </div>
    </header>
  );
}
